import styled, { css } from 'styled-components';
import Link from '@nubank/nuds-web/components/Link/Link';
import { breakpointsMedia } from '@nubank/nuds-web/styles/breakpoints';

const SectionLinkWrapper = styled(Link)`
  ${breakpointsMedia({
    xs: css`
      display: flex;
      align-items: center;
      font-size: 2.25rem;
    `,
    md: css`
      font-size: 4rem;
    `,
    lg: css`
      font-size: 1rem;
    `,
  })}

  &:hover {
    text-decoration: none;
    background: none;
  }
  &:focus {
    text-decoration: none;
    background: none;
  }
`;

SectionLinkWrapper.defaultProps = {
  typographyProps: {
    variant: 'title',
    color: 'black',
  },
};

SectionLinkWrapper.displayName = 'SectionLinkWrapper';

export default SectionLinkWrapper;
